if (!customElements.get('scroll-to')) {
  customElements.define(
    'scroll-to',
    class ScrollTo extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          event.preventDefault();

          const index = this.getAttribute('data-scroll-index');
          const MainContent = document.querySelector('#MainContent');
          const section = MainContent?.querySelectorAll(`.shopify-section`).item(index);
          const headerHeight = document.querySelector('sticky-header')?.offsetHeight || 0;
          const offset = headerHeight + 20;

          if (section) {
            window.scrollTo({
              top: section.offsetTop - offset,
              behavior: 'smooth',
            });
          }
        });
      }
    }
  );
}
